import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { formatMoney } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ first_name: '', last_name: '', phone: '', address: '' });
  const [msg, setMsg] = useState('');
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  const load = async () => {
    const { data } = await api.get('/customers');
    setCustomers(data);
  };
  useEffect(() => { load(); }, []);

  const openAdd = () => { setEditing(null); setForm({ first_name: '', last_name: '', phone: '', address: '' }); setModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ first_name: c.first_name, last_name: c.last_name, phone: c.phone || '', address: c.address || '' }); setModal(true); };

  const handleSave = async () => {
    try {
      if (editing) await api.put(`/customers/${editing.id}`, form);
      else await api.post('/customers', form);
      setModal(false); load();
    } catch (err) { setMsg(err.response?.data?.message || 'خطا'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('آیا مطمئن هستید؟')) return;
    await api.delete(`/customers/${id}`);
    load();
  };

  const filtered = customers.filter(c =>
    `${c.first_name} ${c.last_name} ${c.phone}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-header">
        <h1>مدیریت مشتریان</h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <input className="search-input" placeholder="🔍 جستجو..." value={search} onChange={e => setSearch(e.target.value)} />
          <button className="btn btn-primary" onClick={openAdd}>➕ مشتری جدید</button>
        </div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th><th>نام</th><th>فامیل</th><th>شماره تماس</th><th>آدرس</th>
                <th>بدهی</th><th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, i) => (
                <tr key={c.id}>
                  <td style={{ color: 'var(--text-muted)' }}>{i + 1}</td>
                  <td style={{ fontWeight: 500 }}>{c.first_name}</td>
                  <td>{c.last_name}</td>
                  <td style={{ direction: 'ltr', textAlign: 'right' }}>{c.phone || '—'}</td>
                  <td style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.address || '—'}</td>
                  <td>
                    {Number(c.total_debt) > 0
                      ? <span className="badge badge-danger">{formatMoney(c.total_debt)}</span>
                      : <span className="badge badge-success">ندارد</span>}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-outline btn-sm" onClick={() => navigate(`/loans?customer=${c.id}`)}>وام</button>
                      <button className="btn btn-outline btn-sm" onClick={() => openEdit(c)}>✏️</button>
                      {isAdmin && <button className="btn btn-danger btn-sm" onClick={() => handleDelete(c.id)}>🗑️</button>}
                    </div>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>مشتری یافت نشد</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <span className="modal-title">{editing ? 'ویرایش مشتری' : 'مشتری جدید'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            {msg && <div className="alert alert-danger">{msg}</div>}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">نام *</label>
                <input className="form-control" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">فامیل *</label>
                <input className="form-control" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">شماره تماس</label>
              <input className="form-control" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="07xxxxxxxx" />
            </div>
            <div className="form-group">
              <label className="form-label">آدرس</label>
              <textarea className="form-control" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setModal(false)}>انصراف</button>
              <button className="btn btn-primary" onClick={handleSave}>💾 ذخیره</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
